import {DataSourceType} from '@app/views/admin/application-settings/models/data-source-type.model';

export class RequestResponseAuditInfo {
    public processStatId: string;
    public requestTimestamp: string;
    public responseTimestamp: string;
    public httpMethod: string;
    public requestUri: string;
    public requestUriShort: string;
    public requestHeaders: string;
    public requestBody: string;
    public requestBodyObjectList: ExpandableObject[];
    public responseStatus: number;
    public getResponseStatusText: string;
    public responseStatusText: RESPONSE_STATUS_TEXT;
    public responseHeaders: string;
    public responseBody: string;
    public requestId: string;
    public duration: number;

    constructor(requestTimestamp?: string,
                duration?: number,
                responseStatus?: number,
                responseStatusText?: RESPONSE_STATUS_TEXT,
                httpMethod?: string,
                requestUri?: string,
                requestHeaders?: string,
                requestBody?: string,
                responseBody?: string,
                responseHeaders?: string,
                requestId?: string,
                processStatId?: string
    ) {
        this.requestTimestamp = requestTimestamp;
        this.duration = duration;
        this.responseStatus = responseStatus;
        this.responseStatusText = responseStatusText;
        this.httpMethod = httpMethod;
        this.requestUri = requestUri;
        this.requestHeaders = requestHeaders;
        this.requestBody = requestBody;
        this.responseBody = responseBody;
        this.responseHeaders = responseHeaders;
        this.processStatId = processStatId;
        this.requestId = requestId;
    }
}

export class TransientEtxMessageAuditInfo {
    public etxPersonId: string;
    public etxMessageId: string;
    public districtId: string;
    public processId: string;
    public processStatId: string;
    public schoolId: string;
    public createdAt: Date;
    public messageBody: string;
    public domain: number;
    public id: string;
}

export enum RESPONSE_STATUS_TEXT {
    'SUCCESS'= 'SUCCESS',
    'OK'= 'OK',
    'FAILURE' = 'FAILURE'
}

export const APP_WITH_RESPONSE_STATUS_TEXT = [<string>DataSourceType.GoogleClassroom];

export class JWTHeader {
    kid: string;
    typ: string;
    alg: string;
    cty: string;
    x5c: string;
    x5u: string;
    crit: string;
}

export const JWTHeaderKeyTooltipMap = {
    kid: 'Key ID',
    typ: 'The media type of token',
    alg: 'Signature or encryption algorithm',
    cty: 'Content type',
    x5c: 'X.509 Certificate Chain',
    x5u: 'X.509 Certificate Chain URL',
    crit: 'Critical'
};

export class JWTPayload {
    aud: string;
    sub: string;
    iss: string;
    exp: Date;
    iat: Date;
    jti: string;
    nbf: Date;
}

export const JWTPayloadKeyTooltipMap = {
    aud: 'Audience (who or what the token is intended for)',
    sub: 'Subject (whom the token refers to)',
    iss: 'Issuer (who created and signed this token)',
    exp: 'Expiration time: ', // '<Full time>', / 'Expires: in <X minutes> <full time>',
    iat: 'Issued at ', // '<Full time>', // 'Issued At: <X minutes> ago <full time>',
    jti: 'JWT ID (unique identifier for this token)',
    nbf: 'Not Before:' // '<X minutes>' 'Valid from' / <X minutes>' / Time before which the JWT must not be accepted for processing
};

export class ExpandableObject {
    constructor(
        public key: string = '',
        public value: string = '',
        public isExpanded: boolean = false
    ) {
    }
}
